import { useState } from 'react';
import secureLocalStorage from "react-secure-storage";
import { toast } from 'react-toastify';
import { fetchRequest } from '../../fetchRequest';
import { printProducts } from './receiptPrinter';
import { TOAST_ERR } from './shopUtils';

export function useBankPos({ currentUser, cartProducts, selectedSaleUser, ebarimtTmpData, onSuccess, onSettled, onBeforeRequest }) {
    const [posDisable, setPosDisable] = useState(false);

    const submitBankPos = (requestID = '', portNo = '', terminalID = '', amount = '', posHost = 'http://localhost:8500') => {
        const posSubmitParams = {
            requestID: "dev_eschool_" + requestID,
            portNo,
            timeout: "540000",
            terminalID,
            amount,
            currencyCode: "496",
            operationCode: "1",
            bandWidth: "115200",
            cMode: "",
            cMode2: "",
            additionalData: "",
            cardEntryMode: "",
            fileData: ""
        };
        fetch(posHost + "/requestToPos/message?data=" + btoa(JSON.stringify(posSubmitParams)))
            .then((response) => response.json())
            .then((responseData) => {
                const posSubmitResult = decodeURIComponent(responseData?.PosResult);
                if (posSubmitResult) {
                    const submitRes = JSON.parse(posSubmitResult);
                    const submitResData = atob(submitRes?.data);
                    if (submitRes?.responseCode === '00') {
                        const submitResObj = JSON.parse(submitResData);
                        fetchRequest("app/kiosk/sale/pos-terminal", 'POST', {
                            school: currentUser?.school,
                            submit: 1,
                            posRequest: requestID,
                            posInfo: submitResData,
                            userType: selectedSaleUser?.userType,
                            buyerId: selectedSaleUser?.id,
                            hasEbarimt: currentUser?.hasEbarimt ? 1 : 0,
                            ebarimtType: ebarimtTmpData?.type,
                            ebarimtRegister: ebarimtTmpData?.register
                        })
                            .then(res => {
                                if (res?.success) {
                                    printProducts(res?.products, res?.user, res?.date, res?.ebarimt, res?.schoolCopy, 'BANK_CARD', submitResObj?.pan, res?.fontSize, currentUser);
                                    onSuccess({ statusCode: res?.statusCode, user: res?.user });
                                    setTimeout(() => {
                                        setPosDisable(false);
                                        onSettled();
                                    }, 3500);
                                } else {
                                    setPosDisable(false);
                                    onSettled({ statusCode: res?.statusCode, user: res?.user });
                                    toast.error(res?.message || 'Төлбөр хийхэд алдаа гарлаа', TOAST_ERR);
                                }
                            }).catch(() => {
                                setPosDisable(false);
                                onSettled();
                            });
                    } else {
                        setPosDisable(false);
                        alert('ПОС терминал хүсэлт илгээхэд алдаа гарлаа');
                    }
                } else {
                    setPosDisable(false);
                    alert('ПОС терминал хүсэлт илгээхэд алдаа гарлаа');
                }
            }).catch(() => {
                setPosDisable(false);
            });
    };

    const loadBankPos = (posPort = null, posTerminal = null, posLastConnection = null, requestID = "", totalAmount = 0) => {
        if (posPort && posTerminal) {
            const posHost = secureLocalStorage.getItem("eKioskPosHost") || "http://localhost:8500";
            let posInit = true;
            const now = new Date().getTime();
            if (posLastConnection) {
                if (now > posLastConnection) {
                    if (now - posLastConnection > (10 * 60 * 1000)) {
                        posInit = true;
                    } else {
                        posInit = false;
                    }
                } else {
                    posInit = true;
                }
            }

            if (posInit) {
                const posInitParams = {
                    requestID,
                    portNo: posPort,
                    timeout: "540000",
                    terminalID: posTerminal,
                    amount: "",
                    currencyCode: "496",
                    operationCode: "26",
                    bandWidth: "115200",
                    cMode: "",
                    cMode2: "",
                    additionalData: "",
                    cardEntryMode: "",
                    fileData: ""
                };
                setPosDisable(true);

                fetch(posHost + "/requestToPos/message?data=" + btoa(JSON.stringify(posInitParams)))
                    .then((response) => response.json())
                    .then((responseData) => {
                        const posResult = decodeURIComponent(responseData?.PosResult);
                        if (posResult) {
                            const res = JSON.parse(posResult);
                            if (res?.responseCode === '00') {
                                secureLocalStorage.setItem("eKioskPosLastConnection", now);
                                submitBankPos(requestID, posPort, posTerminal, (totalAmount + "00"), posHost);
                            } else {
                                setPosDisable(false);
                                alert('ПОС терминал хүсэлт илгээхэд алдаа гарлаа');
                            }
                        } else {
                            setPosDisable(false);
                            alert('ПОС терминал хүсэлт илгээхэд алдаа гарлаа');
                        }
                    }).catch(() => {
                        setPosDisable(false);
                        alert('ПОС терминал хүсэлт илгээхэд алдаа гарлаа');
                    });
            } else {
                submitBankPos(requestID, posPort, posTerminal, (totalAmount + "00"), posHost);
            }
        } else {
            toast.error('ПОС тохиргоо хийгдээгүй байна', TOAST_ERR);
        }
    };

    const posRequest = () => {
        if (onBeforeRequest) onBeforeRequest();

        const posPort = secureLocalStorage.getItem("eKioskPosPort");
        const posTerminal = secureLocalStorage.getItem("eKioskPosTerminal");
        const posLastConnection = secureLocalStorage.getItem("eKioskPosLastConnection");

        if (posPort && posTerminal) {
            if (cartProducts && cartProducts.length > 0) {
                const productArray = [];
                let totalAmount = 0;
                for (let p = 0; p < cartProducts.length; p++) {
                    totalAmount += cartProducts[p]?.price * cartProducts[p]?.quantity;
                    productArray.push({
                        id: cartProducts[p]?.id,
                        quantity: cartProducts[p]?.quantity
                    });
                }
                fetchRequest("app/kiosk/sale/pos-terminal", 'POST', {
                    school: currentUser?.school,
                    port: posPort,
                    terminal: posTerminal,
                    amount: totalAmount,
                    products: JSON.stringify(productArray),
                    userType: selectedSaleUser?.userType,
                    buyerId: selectedSaleUser?.id,
                    hasEbarimt: currentUser?.hasEbarimt ? 1 : 0,
                    ebarimtType: ebarimtTmpData?.type,
                    ebarimtRegister: ebarimtTmpData?.register
                })
                    .then(res => {
                        if (res?.success) {
                            loadBankPos(posPort, posTerminal, posLastConnection, res?.requestId, totalAmount);
                        } else {
                            toast.error(res?.message || 'Хүсэлт илгээхэд алдаа гарлаа', TOAST_ERR);
                        }
                    }).catch(() => {
                        toast.error('Хүсэлт илгээхэд алдаа гарлаа', TOAST_ERR);
                    });
            }
        } else {
            toast.error('ПОС тохиргоо хийгдээгүй байна', TOAST_ERR);
        }
    };

    return { posDisable, posRequest };
}
